import { gql } from '@apollo/client';

export const DELIVERIES = gql`
  query deliveries(
      $date: String!,
    ){
    deliveries(date: $date){
      id,
      date,
      phone,
      type_id,
      lead_id,
      address,
      comment,
      user_id,
      status_id,
      contractor_id,
      index,
      time,
      complete,
      created_at
      lead {
        id,
        remonline_id,
        remonline_data,
        remonline_device,
        remonline_model,
        client {
          phone,
          address
        }
      }
    }
  }
`;
